import { GraphQLFormattedError } from 'graphql'

/*
Expects PersonaeApiErrors from Backend as array of this:
    {
        "message":"Could not create Change",
        "errorKey":"entity.could.not.be.created",
        "extensions":{
            "validationErrors":[
                {
                    "field":"validFrom",
                    "message":"Invalid utc date format! Expected: 2019-02-03T14:00:00.000Z - Received: 2019",
                    "errorKey":"invalid.date.format"
                }
            ]
        }
    }
*/
export const hasValidationErrors = (errors: ReadonlyArray<GraphQLFormattedError>): boolean => {
  return errors &&
    errors[0] &&
    errors[0].hasOwnProperty('extensions') &&
    errors[0]['extensions'] &&
    errors[0]['extensions'].hasOwnProperty('validationErrors')
    ? true
    : false
}

export const getValidationErrors = (errors: ReadonlyArray<GraphQLFormattedError>): ValidationErrorsData[] => {
  if (hasValidationErrors(errors)) {
    const validationErrors = errors[0]['extensions']!['validationErrors'] as ValidationErrorsData[]
    if (validationErrors.length > 0) return validationErrors
    // fallback return the global error key
    return [
      {
        errorKey: !!errors[0]['extensions'] && !!errors[0]['extensions']['errorKey'] ? (errors[0]['extensions']['errorKey'] as string) : '',
        field: 'query/mutation',
        message:
          errors[0]['extensions'] && errors[0]['extensions']['message']
            ? (errors[0]['extensions']['message'] as string)
            : errors[0]['message']
            ? errors[0]['message']
            : errors[0]['extensions'] && errors[0]['extensions']['errorKey']
            ? (errors[0]['extensions']['errorKey'] as string)
            : '',
      },
    ]
  } else {
    return []
  }
}
export interface ValidationErrorsData {
  errorKey: string
  field: string
  message: string
}
